import React from "react";
import { Checkbox } from "@mui/material";

import { IColum } from "../../../../../utils/copyToClipboardInXlsFormat";
import { IntlFormatUSD } from "../../../../../utils";
import { CENTS_IN_DOLLAR } from "../../../../../constants";

type IGetAccountsSalesTableColumns = (
  selectedRows: Array<number>,
  handleRowClick: (id: number) => void
) => Array<IColum>;

export const getAccountsSalesTableColumns: IGetAccountsSalesTableColumns = (
  selectedRows,
  handleRowClick
) => {
  const columns: Array<IColum> = [
    {
      by: "",
      title: "",
      path: "id",
      //@ts-ignore
      getCellValue: (rowID: number) => {
        if (!rowID) return "";
        const isSelectedRow = selectedRows.find((selected) => selected === rowID);
        return (
          <Checkbox
            checked={!!isSelectedRow}
            color="default"
            onClick={() => handleRowClick(rowID)}
          />
        );
      },
      //@ts-ignore
      copyToClipBoardCallBack: (rowID: number) => {
        return null;
      },
    },
    {
      by: "id",
      title: "Account ID",
      path: "id",
      isSortable: true,
    },
    {
      by: "name",
      title: "Name",
      path: "name",
      isSortable: true,
    },
    {
      by: "email",
      title: "Email",
      path: "email",
      isSortable: true,
    },
    {
      by: "total_amount",
      title: "Total amount",
      path: "total_amount",
      isSortable: true,
      //@ts-ignore
      getCellValue: (total_amount: number) => {
        return <span>{IntlFormatUSD(total_amount / CENTS_IN_DOLLAR)}</span>;
      },
      //@ts-ignore//@ts-ignore
      copyToClipBoardCallBack: (total_amount: number) => {
        return IntlFormatUSD(total_amount / CENTS_IN_DOLLAR);
      },
    },
    {
      by: "units_sold",
      title: "Units sold",
      path: "units_sold",
      isSortable: true,
    },
  ];

  return columns;
};
